import { useState } from "react";
import { Nav } from "@/components/Nav";
import { DemoBanner } from "@/components/DemoBanner";
import { submitContact } from "@/lib/api";
import { CONTACT } from "@/constants/testIds";

const TYPES = ["Live Action", "GenAI", "Hybrid", "CGI", "Not sure yet"];

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", projectType: TYPES[0], message: "" });
  const [status, setStatus] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setStatus(null);
    try {
      const res = await submitContact(form);
      setStatus({ ok: true, message: res.message });
    } catch (err) {
      setStatus({ ok: false, message: "Something went wrong sending this — please try again." });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#101010] text-[#F5F5F0]" data-testid="contact-page">
      <DemoBanner />
      <Nav />
      <div className="max-w-2xl mx-auto px-4 sm:px-8 pt-12 sm:pt-16 pb-24">
        <p className="font-mono text-sm uppercase tracking-widest text-[#CCFF00] mb-3">Contact</p>
        <h1 className="font-mono text-xl sm:text-2xl tracking-tight leading-snug text-[#F5F5F0]">
          Tell us what you're making.
        </h1>
        <p className="mt-4 text-sm sm:text-base leading-relaxed text-[#888880]">
          Based in Mumbai. Share the brief and we'll get back to you.
        </p>

        <form onSubmit={handleSubmit} className="mt-10 space-y-6">
          <div>
            <label className="block font-mono text-[10px] uppercase tracking-widest text-[#555550] mb-2" htmlFor="name">
              Name
            </label>
            <input
              id="name"
              required
              value={form.name}
              onChange={handleChange("name")}
              data-testid={CONTACT.nameInput}
              className="w-full bg-[#181818] border border-[#2A2A2A] focus:border-[#CCFF00] outline-none px-4 min-h-[44px] font-sans text-sm text-[#F5F5F0] transition-colors"
            />
          </div>
          <div>
            <label className="block font-mono text-[10px] uppercase tracking-widest text-[#555550] mb-2" htmlFor="email">
              Email
            </label>
            <input
              id="email"
              type="email"
              required
              value={form.email}
              onChange={handleChange("email")}
              data-testid={CONTACT.emailInput}
              className="w-full bg-[#181818] border border-[#2A2A2A] focus:border-[#CCFF00] outline-none px-4 min-h-[44px] font-sans text-sm text-[#F5F5F0] transition-colors"
            />
          </div>
          <div>
            <label className="block font-mono text-[10px] uppercase tracking-widest text-[#555550] mb-2" htmlFor="projectType">
              Project Type
            </label>
            <select
              id="projectType"
              value={form.projectType}
              onChange={handleChange("projectType")}
              data-testid={CONTACT.typeSelect}
              className="w-full bg-[#181818] border border-[#2A2A2A] focus:border-[#CCFF00] outline-none px-4 min-h-[44px] font-mono text-xs uppercase tracking-widest text-[#F5F5F0] transition-colors"
            >
              {TYPES.map((t) => (
                <option key={t} value={t}>
                  {t}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="block font-mono text-[10px] uppercase tracking-widest text-[#555550] mb-2" htmlFor="message">
              Message
            </label>
            <textarea
              id="message"
              required
              rows={5}
              value={form.message}
              onChange={handleChange("message")}
              data-testid={CONTACT.messageInput}
              className="w-full bg-[#181818] border border-[#2A2A2A] focus:border-[#CCFF00] outline-none px-4 py-3 font-sans text-sm text-[#F5F5F0] transition-colors resize-none"
            />
          </div>
          <button
            type="submit"
            disabled={submitting}
            data-testid={CONTACT.submitButton}
            className="w-full sm:w-auto px-8 min-h-[44px] bg-[#CCFF00] text-black font-mono text-xs uppercase tracking-widest hover:bg-[#E5FF66] transition-colors disabled:opacity-50"
          >
            {submitting ? "Sending…" : "Send Enquiry"}
          </button>
        </form>

        {status && (
          <div
            data-testid={CONTACT.statusMessage}
            className={`mt-6 font-mono text-xs uppercase tracking-widest px-4 py-3 border ${
              status.ok ? "border-[#CCFF00]/40 text-[#CCFF00]" : "border-red-500/40 text-red-400"
            }`}
          >
            {status.message}
          </div>
        )}
      </div>
    </div>
  );
}
